"use strict";

var PropTypes = require("prop-types");

var classNames = require("classnames");

class SearchSorting extends React.Component {
	constructor(props) {
		super(props);

		var selectedValue;

		if (props.sortType) {
			selectedValue = `${props.sortType.toUpperCase()}_${props.sortAscending ? "true" : "false"}`;
		}

		this.state = {
			availableValues: this.sortingOptions,
			selectedValue
		};
	}

	handleValueSelected(event) {
		var currentSort = this.state.selectedValue;

		var newSort = event.target.value;

		if (currentSort === newSort || this.props.isDesignMode) {
			return;
		}

		var domNode = $(ReactDOM.findDOMNode(this));
		//For the SearchResults component
		var $searchResultsComponent = domNode.closest("[data-component=searchResults]");
		if ($searchResultsComponent.length) {
			window.search($searchResultsComponent.attr("id"), /*page*/0, /*searchText*/undefined, newSort);
		} else {
			//For the Category component
			var $categoryComponent = domNode.closest("[data-component=category]");
			if ($categoryComponent.length) {
				window._categorySearch($categoryComponent.attr("id"), /*pageNumber*/0, newSort);
			}
		}
	}

	getSortingOptions() {
		var config = this.props.sortingConfig || {};

		this.sortingOptions = this.props.reactComponentCategory === "SearchSorting" ? [
		{
			description: config.relevance,
			sortAscending: false,
			value: "RELEVANCE"
		}] : [];

		this.sortingOptions = this.sortingOptions.concat([
			{
				description: config.titleAscending,
				sortAscending: true,
				value: "TITLE"
			},
			{
				description: config.titleDescending,
				sortAscending: false,
				value: "TITLE"
			},
			{
				description: config.startDateDescending, //Newest to Oldest
				sortAscending: false,
				value: "STARTDATE"
			},
			{
				description: config.startDateAscending, //Oldest to Newest
				sortAscending: true,
				value: "STARTDATE"
			}

		]);

		if (this.props.containsOnlyProducts || this.props.isDesignMode) {
			this.sortingOptions = this.sortingOptions.concat([
				{
					description: config.authorAscending,
					sortAscending: true,
					value: "AUTHOR"
				},
				{
					description: config.authorDescending,
					sortAscending: false,
					value: "AUTHOR"
				},
				{
					description: config.priceAscending,
					sortAscending: true,
					value: "PRICE"
				},
				{
					description: config.priceDescending,
					sortAscending: false,
					value: "PRICE"
				}
			]);
		}

		return this.sortingOptions;
	}

	componentDidMount() {
		if (this.props.isDesignMode) {
			//To add or remove react components from window, edit JavaScript\searchComponents\expose.jsx
			parent.window.ComponentActions.childComponentLoaded(this);
		}
	}

	componentWillUnmount() {
		if (this.props.isDesignMode) {
			//To add or remove react components from window, edit JavaScript\searchComponents\expose.jsx
			parent.window.ComponentActions.childComponentUnloaded(this);
		}
	}

	render() {
		var sortingOptions = this.getSortingOptions();
		var availableValues = sortingOptions || this.state.availableValues || [];

		// if (this.props.isDesignMode) {
		// 	numberPagesToShow = numberPagesToShow || 3;
		// }

		return (
			<div
				className="search-sorting"
				data-react-component-name="SearchSorting"
				data-react-component-category={this.props.reactComponentCategory}
				data-component-id={this.props.dataComponentId}
				data-nested-id={this.props.dataNestedId}
				data-repeated-id={this.props.dataRepeatedId}
				data-theme={+this.props.theme ? this.props.theme : undefined}
				data-custom={this.props.isCustomTheme || null}
				data-child-of={this.props.dataChildOf}
			>
				<select
					className={classNames("form-control", "search-sorting-selector")}
					style={this.props.isDesignMode ? {"pointerEvents": "none"} : undefined}
					data-override-classes={this.props.childClass}
					disabled={this.state.disabled || (!this.props.isDesignMode && (!availableValues || !availableValues.length))}
					name={this.props.selectNameAttribute}
					onChange={this.handleValueSelected.bind(this)}
					value={this.state.selectedValue}
				>
					<option value=""></option>
					{availableValues && availableValues.map((availableValue) => {
						var value = `${availableValue.value}_${availableValue.sortAscending.toString()}`;

						return (
							<option className={this.props.optionsClassName} key={value} value={value}>
								{availableValue.description}
							</option>
						);
					})}
				</select>
			</div>
		);
	}
}

SearchSorting.propTypes = {
	isDesignMode: PropTypes.bool,
	dataChildOf: PropTypes.string,
	theme: PropTypes.string,
	isCustomTheme: PropTypes.bool,
	dataRepeatedId: PropTypes.string,
	dataComponentId: PropTypes.string,
	dataNestedId: PropTypes.string,
	reactComponentCategory: PropTypes.string,
	sortingConfig: PropTypes.object,
	sortType: PropTypes.string,
	sortAscending: PropTypes.bool,
	containsOnlyProducts: PropTypes.bool
};

module.exports = SearchSorting;
